(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["forcast-card-swatches"] && !Shopify.designMode) return;
  try {
    // Swatch hover → switch the card to that colour, and leave it switched.
  //
  // Colours are combined-listing children, so the colour on screen and the
  // colour quick add would bag are only the same if the card actually
  // re-points itself: gallery images, links and size buttons all move to the
  // hovered colour's product (data rendered by forcast-card-colour-data).
  //
  // Delegated once per page; pointerenter/focus don't bubble, so we use
  // pointerover/focusin with a relatedTarget guard.
  const DOT_SELECTOR = '.forcast-card-swatches__dot[data-colour-data]';
  const HIDDEN_BY_US = 'forcastColourHidden';

  function readColourData(dot) {
    try {
      return JSON.parse(dot.dataset.colourData);
    } catch {
      return null;
    }
  }

  // Point the gallery at the colour's own photos. Slides past the colour's
  // image count are hidden (with their tracker dots) so paging the card can
  // never land on another colour's photography; the last image repeats only
  // if there is nothing left to hide.
  function applyImages(card, images) {
    if (!images.length) return;

    for (const el of card.querySelectorAll('[data-forcast-colour-hidden]')) {
      el.removeAttribute('hidden');
      delete el.dataset[HIDDEN_BY_US];
    }

    const slides = card.querySelectorAll('slideshow-slide:not([hidden])');
    const dots = card.querySelectorAll('.card-gallery__tracker li');

    slides.forEach((slide, index) => {
      const img = slide.querySelector('img');
      if (!img) return;

      // Only ever hide slides we can restore — the gallery hides variant
      // images of its own accord and those must stay hidden.
      if (index >= images.length && index > 0) {
        slide.dataset[HIDDEN_BY_US] = 'true';
        slide.setAttribute('hidden', '');
        const dot = dots[index];
        if (dot) {
          dot.dataset[HIDDEN_BY_US] = 'true';
          dot.setAttribute('hidden', '');
        }
        return;
      }

      const src = images[Math.min(index, images.length - 1)];
      if (img.getAttribute('src') === src) return;
      img.setAttribute('src', src);
      // A single fixed width replaces the responsive set: these are hover
      // swaps, and 900px covers a card at 2x on the widest grid.
      img.removeAttribute('srcset');
    });
  }

  function applyLinks(card, url) {
    if (!url) return;
    const links = card.querySelectorAll(
      '.product-card__link, [ref="cardGalleryLink"], [ref="productTitleLink"]'
    );
    for (const link of links) link.setAttribute('href', url);
  }

  function applySizes(card, sizes, productId) {
    const overlay = card.querySelector('.product-card__size-overlay');
    const values = card.querySelector('.product-card__size-overlay-values');
    if (!overlay || !values) return;

    // A colour with no size run has nothing to quick add.
    overlay.style.display = sizes.length ? '' : 'none';
    if (!sizes.length) return;

    values.replaceChildren(
      ...sizes.map((size) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'product-card__size-overlay-value';
        button.style.order = String(size.order);
        button.dataset.quickAddVariantId = String(size.id);
        button.dataset.quickAddProductId = String(productId);
        button.disabled = size.available === false;
        button.setAttribute('aria-label', `Add size ${size.label} to bag`);
        button.textContent = size.label;
        return button;
      })
    );
  }

  function selectColour(dot) {
    const card = dot.closest('product-card');
    if (!card || dot.classList.contains('forcast-card-swatches__dot--selected')) return;

    const data = readColourData(dot);
    if (!data) return;

    for (const sibling of dot.parentElement?.children ?? []) {
      sibling.classList.remove('forcast-card-swatches__dot--selected');
      sibling.removeAttribute('aria-current');
    }
    dot.classList.add('forcast-card-swatches__dot--selected');
    dot.setAttribute('aria-current', 'true');

    applyImages(card, data.images ?? []);
    applyLinks(card, data.url);
    applySizes(card, data.sizes ?? [], data.productId);
  }

  document.addEventListener('pointerover', (event) => {
    if (!(event.target instanceof Element)) return;
    const dot = event.target.closest(DOT_SELECTOR);
    if (!dot || dot.contains(event.relatedTarget)) return;
    selectColour(dot);
  });

  document.addEventListener('focusin', (event) => {
    if (!(event.target instanceof Element)) return;
    const dot = event.target.closest(DOT_SELECTOR);
    if (dot) selectColour(dot);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    // Instalments "Learn more" → right-side payment options drawer.
  // Delegated once; works for every price block on the page. Close plays the
  // theme's drawer slide-out (.dialog-closing) before the dialog is removed,
  // mirroring the cart drawer.
  const closeInstalments = (dialog) => {
    if (!dialog || !dialog.open || dialog.dataset.closing === 'true') return;
    dialog.dataset.closing = 'true';

    const finish = () => {
      if (dialog.dataset.closing !== 'true') return;
      dialog.dataset.closing = 'false';
      dialog.classList.remove('dialog-closing');
      dialog.close();
    };

    dialog.classList.add('dialog-closing');
    // Prefer the slide-out animation end, but always close via a fallback
    // timeout (the open/close share the move-and-fade name, so animationend
    // can fail to re-fire). The fallback tracks the 300ms close animation with
    // a small margin — it used to be 650ms, which held the drawer on screen
    // long after the movement had finished.
    dialog.addEventListener('animationend', finish, { once: true });
    setTimeout(finish, 370);
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const openBtn = event.target.closest('[data-forcast-instalments-open]');
    if (openBtn) {
      const dialog = openBtn
        .closest('product-price')
        ?.querySelector('[data-forcast-instalments-dialog]');
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }

    const closeBtn = event.target.closest('[data-forcast-instalments-close]');
    if (closeBtn) {
      closeBtn.closest('dialog')?.close();
      return;
    }

    // Click on the backdrop (the dialog element itself, outside the panel).
    if (event.target.matches('[data-forcast-instalments-dialog]')) {
      event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
